import styled from 'styled-components/macro';
import { ListCheckTabStrip } from '../../../styles';

export const TemplateLine = styled.p`
  margin: 2px 0 0;
  font-size: 13px;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const TabRow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding-top: 16px;

  & > ${ListCheckTabStrip} {
    margin-top: 0;
    align-self: center;
  }
`;

export const ViewSwitchSpacer = styled.span`
  flex: 1;
`;

export const CouldNotTellLine = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const ExpectedLine = styled.span`
  font-family: monospace;
  font-size: 11px;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.color.gray[400]};
`;

export const RulesFound = styled.p`
  margin: 0 0 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.gray[700]};
`;

export const ResultLines = styled.div`
  display: grid;
  gap: 8px;
  margin-bottom: 16px;
`;

export const OverviewIntro = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.color.gray[600]};
`;

export const TileRow = styled.p<{ $support: boolean; $found: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 0;
  font-size: 14px;
  color: ${({ $support, theme }) => ($support ? theme.color.gray[500] : theme.color.gray[900])};

  b {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${({ $support, $found, theme }) =>
      !$support && $found
        ? theme.color.red[500]
        : $support
        ? theme.color.gray[500]
        : theme.color.gray[700]};
  }
`;
